import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import { Table, Input, Button, Space, Select, Tag } from "antd";
import fron from "../../../font/Poppins-Regular.ttf";
import moment from "moment";

const COL1_WIDTH = 40;

Font.register({
  family: "Poppins-Regular",
  src: fron,
});

const styles = StyleSheet.create({
  tbl: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
  },
  tableHeader: {
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 0 0 0",
    padding: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    border: "1px solid #f1f1f1",
    backgroundColor: "#f1f1f1",
    minHeight: 30,
    maxHeight: 60,
  },
  row: {
    display: "flex",
    flexWrap: "nowrap",
    padding: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    border: "1px solid #f1f1f1",
    minHeight: 30,
    maxHeight: 60,
  },
  cell: {
    padding: "5px 5px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100px",
    flexWrap: "wrap",
    width: "100px",
    wordBreak: "break-all",
  },

  cell2: {
    paddingLeft: "15px",
    paddingTop:"5px",
    paddingBottom:"5px",
    paddingRight:"5px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100px",
    flexWrap: "wrap",
    width: "100px",
    wordBreak: "break-all",
  },
  cell3: {
    padding: "3px 3px",
    fontFamily: "Poppins-Regular",
    fontSize: "9px",
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "100px",
    flexWrap: "wrap",
    width: "100px",
    wordBreak: "break-all",
  },
  firstCell: {
    padding: "5px 5px",
    flexGrow: 1,
    flexShrink: 2,
    fontSize: "9px",
    flexBasis: "160px",
    width: "160px",
    fontFamily: "Poppins-Regular",
  },
  indexCell: {
    padding: "5px 5px",
    flexGrow: 1,
    flexShrink: 1,
    fontSize: "9px",
    flexBasis: "10px",
    wordBreak: "break-all",
    width: "10px",
    fontFamily: "Poppins-Regular",
    backgroundColor: "#f1f1f1",
  },

  header: {
    padding: 15,
    display: "flex",
    marginBottom: 15,
  },
});
// Create Document Component
export const Document2 = (props) => (
  <Document>
    <Page size="A4" wrap>
      <View style={styles.header}>
        <Text
          style={{
            fontSize: "14px",
            fontWeight: 600,
            marginBottom: 8,
            fontFamily: "Poppins-Regular",
          }}
        >
          (CMIS)-आरोपी सांख्यिकी अहवाल
        </Text>
        <Text style={{ fontSize: "14px", marginBottom: 8 }}>
          {props.filterDate
            ? "From: " +
              moment(props.filterDate && props.filterDate.startDate).format(
                "DD-MM-YYYY"
              )
            : null}
        </Text>
        <Text style={{ fontSize: "14px", fontFamily: "Poppins-Regular" }}>
          एकूण आरोपी :{props.total && props.total}
        </Text>
      </View>

      <View style={styles.tbl}>
        <View style={styles.tableHeader}>
          <Text style={styles.indexCell}>अ.क्र.</Text>
          <Text style={styles.cell}>पोलिस ठाणे</Text>
          <Text style={styles.cell}>एकूण आरोपी</Text>
          <Text style={styles.cell}>पो. स्टे. नी भरलेली माहिती</Text>
        </View>
      </View>

      {props &&
        props.rows &&
        props.rows.map((item, index) => (
          <View key={index} style={styles.row} wrap={false}>
            <Text style={styles.indexCell}>{index + 1}</Text>
            <Text style={styles.cell}>{item.policeThane}</Text>
            <Text style={styles.cell}>{item.totalCriminals}</Text>
            <Text style={styles.cell}>{item.allTotalCriminalsbyUser}</Text>
          </View>
        ))}
    </Page>
  </Document>
);

export const PreventiveDocument = (props) => (
  console.log("props", props),
  (
    <Document>
      <Page size="A4" wrap>
        <View style={styles.header}>
          <Text
            style={{
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: 8,
              fontFamily: "Poppins-Regular",
            }}
          >
            प्रतिबंधक कारवाई
          </Text>
          <Text style={{ fontSize: "14px", marginBottom: 8 }}>
            {props.filterDate
              ? "From: " +
                moment(props.filterDate && props.filterDate.startDate).format(
                  "DD-MM-YYYY"
                ) +
                "to" +
                moment(props.filterDate && props.filterDate.endDate).format(
                  "DD-MM-YYYY"
                )
              : null}
          </Text>
        </View>

        <View style={styles.tbl}>
          <View style={styles.tableHeader}>
            <Text style={styles.cell}>अ.क्र.</Text>
            <Text style={styles.cell}>नाव</Text>
            <Text style={styles.cell}>वय</Text>
            <Text style={styles.cell}>फोन नंबर</Text>
            <Text style={styles.cell}>आरोपीचे पोलिस ठाणे</Text>
            <Text style={styles.cell}>प्रतिबंधक कारवाई</Text>
            <Text style={styles.cell}>फोटो</Text>
          </View>
        </View>

        {props &&
          props.rows &&
          props.rows.map((item, index) => (
            <View key={index} style={styles.row} wrap={false}>
              <Text style={styles.cell}>{index + 1}</Text>
              <Text style={styles.cell}>{item.name}</Text>
              <Text style={styles.cell}>{item.age}</Text>
              <Text style={styles.cell}>{item.mobileNumber}</Text>
              <Text style={styles.cell}>{item.address}</Text>
              <Text style={styles.cell}>{item.preventiveActionName}</Text>
              <Text style={styles.cell}>
                {item.photo[0].length > 0 ? "हो" : "नाही"}
              </Text>
            </View>
          ))}
      </Page>
    </Document>
  )
);

export const DocumentCount = (props) => {
  console.log("props count", props);
  const preventiveActions = props.columnData.map((action) => action.name);

  return (
    <Document>
      <Page size="A4" wrap>
        <View style={styles.header}>
          <Text
            style={{
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: 8,
              fontFamily: "Poppins-Regular",
            }}
          >
            प्रतिबंधक कारवाई - आकडेवारी
          </Text>
          <Text style={{ fontSize: "14px", marginBottom: 8 }}>
            {props.filterDate
              ? "From: " +
                moment(props.filterDate.startDate).format("DD-MM-YYYY") +
                " to " +
                moment(props.filterDate.endDate).format("DD-MM-YYYY")
              : null}
          </Text>
        </View>

        <View style={styles.tbl}>
          <View style={styles.tableHeader}>
            <Text style={styles.indexCell}>अ.क्र.</Text>
            <Text style={styles.cell2}>पोलिस ठाणे</Text>
            {preventiveActions.map((actionName, index) => (
              <Text key={index} style={styles.cell3}>
                {actionName}
              </Text>
            ))}
          </View>
        </View>

        {props.rows &&
          props.rows.map((item, index) => (
            <View key={index} style={styles.row} wrap={false}>
              <Text style={styles.indexCell}>{index + 1}</Text>
              <Text style={styles.cell}>{item.districtName}</Text>
              <Text style={styles.cell}>
                {item["एम पी डी ए सीआरपीसी कलम 151(3)"]}
              </Text>
              <Text style={styles.cell}>
                {item["मंबई दारूबंदी कायदा कलम 93"]}
              </Text>
              <Text style={styles.cell}>{item["मपोका कलम 55"]}</Text>
              <Text style={styles.cell}>{item["मपोका कलम 56"]}</Text>
              <Text style={styles.cell}>{item["मपोका कलम 57"]}</Text>
              <Text style={styles.cell}>{item["मपोका कलम 68/69"]}</Text>
              <Text style={styles.cell}>
                {item["महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)"]}
              </Text>
              <Text style={styles.cell}>{item["सीआरपीसी कलम 107"]}</Text>
              <Text style={styles.cell}>{item["सीआरपीसी कलम 109"]}</Text>
              <Text style={styles.cell}>{item["सीआरपीसी कलम 110"]}</Text>
              <Text style={styles.cell}>{item["सीआरपीसी कलम 144 (3)"]}</Text>
              <Text style={styles.cell}>{item["सीआरपीसी कलम 151"]}</Text>
            </View>
          ))}
      </Page>
    </Document>
  );
};
